/**
 * 查找 url中 键名为 key 的查询参数，并删除
 * @param url
 * @param key
 */
export function spliceQueryParameter(url, key) {
  if (!url || !key) {
    return url;
  }
  return url.replace(new RegExp('(^|\\?)' + key + '=([^&]*)(^&|$)'), '').replace(new RegExp('(^|\\?)' + key + '=([^&]*)(&|$)'), '?').replace(new RegExp('(^|&)' + key + '=([^&]*)(|$)'), '?');
}
export default {
  spliceQueryParameter: spliceQueryParameter
};